<script lang="ts">
    import Menu from "../Menu.svelte";
    import { getMessage } from "@app/services/i18n.service";
    import {
        COMMON__logout,
        USER__userProfileLink,
    } from "@app/services/i18n.messages";
    export let open: boolean = false;
    export let onClose: () => void;
    export let userId: string;
    const redirectUrl = window.location.toString();

    let logoutUrl =
        (window as any).glosbe?.logoutUrl ||
        "https://auth2.glosbe.com/doLogout";
</script>

<Menu {open} {onClose}>
    <li>
        <a
            href="https://app.glosbe.com/profile/{userId}"
            class="px-4 py-2 block w-full h-full hover:bg-gray-100 text-gray-700"
        >
            {getMessage(USER__userProfileLink)}
        </a>
    </li>
    <li>
        <form action={logoutUrl} method="post">
            <input name="returnUrl" value={redirectUrl} type="hidden" />
            <button
                class="px-4 py-2 block w-full h-full hover:bg-gray-100
        text-gray-700"
            >
                {getMessage(COMMON__logout)}
            </button>
        </form>
    </li>
</Menu>

<style>
    a,
    button {
        color: #4a5568 !important;
    }
</style>
